import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import {
  AnimationDirective,
  AnimationsConfig,
} from '@plugins/client/directives/animation.directive';
import { TranslatePipe } from '@plugins/client/translate/pipes';

import { DisplayIf } from '../types';

@Component({
  selector: 'plugins-form-control-error',
  imports: [CommonModule, TranslatePipe, AnimationDirective],
  templateUrl: './form-control-error.component.html',
  styleUrl: './form-control-error.component.scss',
})
export class FormControlErrorComponent {
  @Input() control!: AbstractControl;
  @Input() translateVars: Record<string, string | number> = {};
  @Input() displayIf: DisplayIf = 'dirty';
  @Input() displayValue = false;

  id = 'error-' + Math.random().toString(36).substring(2);
  private displayPriority = ['pristine', 'touched', 'dirty'] as const;

  readonly animations: AnimationsConfig = {
    enter: {
      type: ['fade', 'growY'],
      timingOptions: { duration: 150, fill: 'forwards' },
    },
  };

  get displayConditionMet(): boolean {
    const checkList = this.displayPriority.slice(
      this.displayPriority.indexOf(this.displayIf),
    );
    if (checkList.length) {
      for (const condition of checkList) {
        if (this.control[condition]) {
          return true;
        }
      }
    }
    return false;
  }
}
